export const ProductionInspectionPage = () => {
  return <>ProductionInspectionPage</>;
};
